import OrcamentoService from "@/services/OrcamentoService";
import { router } from "@/router";
import helper from "@/helper";

export const actions = {
  cadastrarOrcamento: ({ commit, dispatch }) => {
    commit("setOrcamento", {
      subtotal: 0,
      desconto: 0,
      total: 0,
      cliente_id: 1,
      itens: [],
      formas_pagamentos: [],
      proximo_contato: "",
    });
    commit("setItensOrcamento", []);
    commit(`setContato`, {});
    commit(`setProduto`, {});
    router.push({ name: "orcamentoCadastro" });
    // commit('setModalCadastroOrcamento', true)
    dispatch("setModalEnviarEmailOrcamento", false)
    
  },
  listarOrcamentos: ({ commit }, data) => {
    commit("setOverlay", true);
    OrcamentoService.listar(data)
      .then((res) => {
        commit("setOrcamentos", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  setOrcamento: ({ commit }, data) => {
    data.itens.forEach((e) => {
      let item = {
        produto_id: e.produto_id,
        descricao: e.descricao != null ? e.descricao : e.produto.descricao,
        preco: e.preco,
        quantidade: e.quantidade,
        subtotal: e.subtotal,
        desconto: e.desconto ? e.desconto : 0,
        total: e.total,
        estoque: helper.getEstoquePrincipalProduto(e.produto),
      };
      commit("addItemOrcamento", item);
    });

    let orcamento = data;
    orcamento.subtotal = helper.formatReal(parseFloat(data.subtotal));
    orcamento.desconto = helper.formatReal(parseFloat(data.desconto));
    orcamento.total = helper.formatReal(parseFloat(data.total));

    if (data.cliente) {
      commit("setContato", data.cliente);
    }
    commit("setOrcamento", orcamento);
  },
  visualizarOrcamento: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    commit("setItensOrcamento", []);
    OrcamentoService.editar(id)
      .then((res) => {
        let data = res.data;
        data.formas_pagamentos == null ? (data.formas_pagamentos = []) : (data.formas_pagamentos = res.data.formas_pagamentos);
        dispatch("setOrcamento", data);
        commit("setOverlay", false);
        // commit("setModalCadastroOrcamento", true);
        if (res.data.cliente) {
          commit("setContato", res.data.cliente);
        } else {
          commit("setContato", {});
        }
      })
      .catch((e) => {
        commit("setOverlay", false);
      });
  },
  salvarOrcamento: ({ commit, dispatch }, data) => {
    data.subtotal = parseFloat(
      data.subtotal
        .toString()
        .replace(".", "")
        .replace(",", ".")
    );
    // data.desconto =
    //   parseFloat(
    //     data.subtotal
    //       .toString()
    //       .replace(".", "")
    //       .replace(",", ".")
    //   ) - parseFloat(data.total.replace(".", "").replace(",", "."));
    data.total = parseFloat(data.total.replace(".", "").replace(",", "."));
    data.itens = data.itens;
    data.cliente_id = data.cliente_id;

    commit("setOverlay", true);
    OrcamentoService.salvar(data)
      .then((res) => {
        // commit('setItensOrcamento', [])
        // dispatch('setOrcamento', res.data)
        router.push({ name: "orcamentoEditar", params: { id: res.data.id } });
        dispatch("visualizarOrcamento", res.data.id);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Orçamento salvo.");
        dispatch("setModalImprimirOrcamento", true);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao salvar orçamento.");
      });
  },
  atualizarOrcamento: ({ commit, dispatch }, data) => {
    data.subtotal = parseFloat(
      data.subtotal
        .toString()
        .replace(".", "")
        .replace(",", ".")
    );
    // data.desconto =
    //   parseFloat(
    //     data.subtotal
    //       .toString()
    //       .replace(".", "")
    //       .replace(",", ".")
    //   ) - parseFloat(data.total.replace(".", "").replace(",", "."));
    data.total = parseFloat(data.total.replace(".", "").replace(",", "."));
    data.itens = data.itens;
    data.cliente_id = data.cliente_id;

    commit("setOverlay", true);
    OrcamentoService.atualizar(data)
      .then((res) => {
        let data = res.data;
        // dispatch("listarOrcamentos", {});
        commit("setOrcamento", {
          ...data,
          subtotal: helper.formatReal(parseFloat(res.data.subtotal)),
          desconto: helper.formatReal(parseFloat(res.data.desconto)),
          total: helper.formatReal(parseFloat(res.data.total)),
        });

        commit("setOverlay", false);
        commit("snackbarInfo", "Orçamento salvo.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar orçamento.");
      });
  },
  excluirOrcamento: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    dispatch("setModalCadastroOrcamento", false);
    dispatch("setModalExcluirOrcamento", false);
    OrcamentoService.excluir(id)
      .then((res) => {
        router.push({ name: "orcamentos" });
        commit("setOverlay", false);
        commit("snackbarError", "Orçamento excluído.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
        commit("snackbarError", "Erro ao excluir orçamento.");
      });
  },
  enviarEmailOrcamento: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    OrcamentoService.enviarEmail(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "E-mail enviado com sucesso.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao enviar e-mail.");
      });
  },
  setModalCadastroOrcamento: ({ commit }, status) => {
    commit("setModalCadastroOrcamento", false);
    setTimeout(() => {
      commit("setModalCadastroOrcamento", status);
    }, 100);
  },
  setModalExcluirOrcamento: ({ commit }, status) => {
    commit("setModalExcluirOrcamento", false);
    setTimeout(() => {
      commit("setModalExcluirOrcamento", status);
    }, 100);
  },
  addItemOrcamento: ({ commit }, data) => {
    commit("addItemOrcamento", data);
  },
  removeItemOrcamento: ({ commit }, item) => {
    commit("removeItemOrcamento", item);
  },
  setItensOrcamento: ({ commit }, data) => {
    commit("setItensOrcamento", data);
  },
  setItemOrcamento: ({ commit }, data) => {
    commit("setItemOrcamento", data);
  },
  setModalPesquisarProdutosOrcamento: ({ commit }, status) => {
    commit("setModalPesquisarProdutosOrcamento", false);
    setTimeout(() => {
      commit("setModalPesquisarProdutosOrcamento", status);
    }, 100);
  },
  selecionarProdutoOrcamento: ({ commit }, id) => {},
  setModalAdicionarProdutoOrcamento: ({ commit }, status) => {
    commit("setModalAdicionarProdutoOrcamento", false);
    setTimeout(() => {
      commit("setModalAdicionarProdutoOrcamento", status);
    }, 100);
  },
  converterOrcamentoParaVenda: ({ commit, dispatch }, data) => {
    commit("setItemOrcamento", []);
    dispatch("cadastrarVenda");
    commit('setFuncionario', data.funcionario)
    const venda = {
      subtotal: data.subtotal,
      desconto: data.desconto,
      total: data.total,
      cliente_id: data.cliente_id,
      orcamento_id: data.id,
      valor_pago: '0,00',
      troco: '0,00',
      acrescimo: 0,
    };

    // const quantidadeProdutosEstoquePositivo  = data.itens.filter(item => item.estoque >= item.quantidade).length

    data.itens.map((o) => {
      dispatch("addProdutoVenda", {
        produto_id: o.produto_id,
        descricao: o.descricao ? o.descricao : o.produto.descricao,
        preco: parseFloat(o.preco),
        quantidade: parseFloat(o.quantidade),
        subtotal: o.subtotal ? parseFloat(o.subtotal) : 0,
        desconto: o.desconto ? parseFloat(o.desconto) : 0,
        total: parseFloat(o.total),
        grade_id: o.grade_id,
      });
    });

    // data.itens.map((o) => {
    //   if (o.estoque >= o.quantidade) {
    //     dispatch("addProdutoVenda", {
    //       produto_id: o.produto_id,
    //       descricao: o.descricao ? o.descricao : o.produto.descricao,
    //       preco: parseFloat(o.preco),
    //       quantidade: parseFloat(o.quantidade),
    //       desconto: o.desconto ? parseFloat(o.desconto) : 0,
    //       total: parseFloat(o.total),
    //     });
    //   } else {
    //     venda.subtotal = helper.cleanFormatReal(venda.subtotal.toString()) - o.total;
    //     venda.total = helper.cleanFormatReal(venda.total.toString()) - o.total;
    //   }
    // });

    commit("setVenda", venda);
    if (data.cliente) {
      commit("setContato", data.cliente);
    }
    dispatch("aplicaDescontoVenda");

    router.push({ name: "vendaConverter" });
    // if(quantidadeProdutosEstoquePositivo > 0){
    //     commit('setVenda', venda)
    //     commit('setContato', data.cliente)
    //     dispatch('aplicaDescontoVenda')

    //     router.push({name: 'vendaConverter'})
    // }else{
    //     commit('snackbarWarning', 'Todos os produtos deste orçamento estão com estoque insuficiente.');
    // }
  },
  imprimirOrcamento4a: ({ commit }, id) => {
    commit("setOverlay", true);
    OrcamentoService.imprimirA4(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir orçamento.");
      });
  },
  imprimirOrcamentoCupom: ({ commit }, id) => {
    commit("setOverlay", true);
    OrcamentoService.imprimirCupom(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir orçamento.");
      });
  },
  setModalInfoProposta({commit}, payload) {
    commit("setModalInfoProposta", false);
    commit("setModalInfoProposta", payload);
  },
  imprimirPropostaA4: ({ commit }, data) => {
    commit("setModalInfoProposta", false);
    commit("setInfoProposta", {
      loja:
        "Piscina, cavação, instalação hidráulica com tubulação de 50mm, 1ª limpeza com nossos produtos, equipamentos (casa de maquina, filtro e bomba) e ponto de cascata, kit acessório (cabo, peneira, aspirador, escovão, ponteira, adaptador e mangueira), hidro (retorno), 02 ralo de fundo com tampa de proteção ante-sucção.",
      cliente:
        "Água, ponto de energia 110 ou 220 com 01 disjuntor dentro da casa de máquina com uma haste de aterramento de 1 metro com conecto, complemento de dreno e retirada do aterro da frente da sua casa/obra, terreno livre para cavação, retirada de cerca elétrica, caso haja e reposição de telha.",
      validade: "30 dias",
      prazo_entrega: "8 a 15 dias",
    });
    commit("setOverlay", true);
    OrcamentoService.imprimirPropostaA4(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir orçamento.");
      });
  },
  setModalImprimirOrcamento: ({ commit }, status) => {
    commit("setModalImprimirOrcamento", false);
    setTimeout(() => {
      commit("setModalImprimirOrcamento", status);
    }, 100);
  },
  setModalEnviarEmailOrcamento: ({ commit }, status) => {
    commit("setModalEnviarEmailOrcamento", false);
    setTimeout(() => {
      commit("setModalEnviarEmailOrcamento", status);
    }, 100);
  },
};

export default {};
